// const languageId = 'pl-PL';
const languageId = 'en-UK';

export const formatNumber: (number: number) => string = number =>
  new Intl.NumberFormat(languageId, { style: 'decimal' }).format(number);
